import { Flex } from '@utilitywarehouse/hearth-react';

import Awards from './Awards';
import Footer from './Footer';
import Header from './Header';

function Layout({
  children,
  partnerName,
}: {
  children: React.ReactNode;
  partnerName?: string;
}) {
  return (
    <Flex direction="column" minHeight="100dvh">
      <Header partnerName={partnerName} />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </main>
      <Awards />
      <Footer />
    </Flex>
  );
}

export default Layout;
